import React from "react";
import LegalPage from "./LegalPage";

export default function PrivacyPage() {
  return (
    <LegalPage
      eyebrow="Legal · House Rules"
      title="Privacy|Policy."
      updated="February 2026"
      summary="We collect the minimum data we need to ship you a box and never sell it to anyone else. Here's exactly what we collect, why, and how you stay in control."
      sections={[
        {
          id: "collect",
          heading: "1. What we collect",
          body: [
            "We collect the information you give us at checkout (name, email, shipping address, phone number) and basic order data (items purchased, amount paid, order ID). Payment card details are handled entirely by Stripe - we never touch them.",
            "We also collect anonymized usage data via cookies and analytics (pages visited, buttons clicked, device type) so we can improve the site. This data does not identify you personally by default.",
          ],
        },
        {
          id: "use",
          heading: "2. How we use it",
          body: [
            [
              "Fulfilment: printing labels, shipping your order, and sending tracking updates",
              "Customer support: responding to your emails and resolving return requests",
              "Marketing (opt-in only): new deck launches, seasonal deals, and behind-the-scenes updates. You opt in at checkout and can unsubscribe with one click",
              "Analytics: understanding which decks are most loved and improving the site",
            ],
          ],
        },
        {
          id: "share",
          heading: "3. Who we share it with",
          body: [
            "We only share data with the vendors we need to run the business:",
            [
              "Stripe - payment processing",
              "Easyship - carrier rates, labels, and tracking",
              "MongoDB Atlas & our hosting provider - encrypted data storage",
              "Resend/SendGrid - transactional emails (order confirmations, shipping updates)",
            ],
            "We never sell, rent, or trade your personal information with advertisers or data brokers.",
          ],
        },
        {
          id: "cookies",
          heading: "4. Cookies & tracking",
          body: [
            "We use essential cookies for the cart, checkout, and admin session - these are required for the site to function. We also use privacy-respecting analytics to understand how the site is used.",
            "You can block non-essential cookies via your browser settings without breaking the checkout flow.",
          ],
        },
        {
          id: "rights",
          heading: "5. Your rights",
          body: [
            "You can request a copy of your data, correct inaccurate information, or ask us to delete your account and personal data at any time. Email hello@houserules.game and we'll respond within 30 days.",
            "California residents have additional rights under the CCPA. EU/UK residents have rights under GDPR - including data portability and the right to object to processing. Both are honoured on request.",
          ],
        },
        {
          id: "retention",
          heading: "6. How long we keep it",
          body: [
            "Order records are retained for 7 years for tax and accounting purposes. Marketing preferences are kept until you unsubscribe. Analytics data is anonymized after 26 months.",
          ],
        },
        {
          id: "contact",
          heading: "7. Contact us",
          body: [
            "For any privacy question, email hello@houserules.game or write to Wall of Entertainment Inc., Los Angeles, CA. We aim to respond within 3 business days.",
          ],
        },
      ]}
      related={[
        { label: "Terms & Conditions", to: "/terms" },
        { label: "Returns Policy", to: "/returns" },
        { label: "Shipping Info", to: "/shipping" },
      ]}
    />
  );
}
